import { TipiRichiestaRiepiloghiSpecifica, Chiamata, ChiamataNew, StatoFiltroChiamate } from './models';
import { DestinatarioMatricola, TipoIntervento } from '../core-assistenza';
import { query, command } from '../api';
import { ApplicationState } from '..';
import { PageResult } from '../core';

export const getDestinatariMatricole = (
    state: ApplicationState,
    tipologia: TipoIntervento, 
    search: string, 
    refreshCache: boolean
): Promise<DestinatarioMatricola[]> => {
    const url: string = '/api/matricole/raggruppate';
    const cacheType: RequestCache = refreshCache ? "reload" : "default";
    const parametri: Object = { 
        search, 
        tipologia 
    };

    return query<DestinatarioMatricola[]>(url, state, parametri, cacheType);
}

export const getTipiRichiestaRiepilogoSpecifica = (
    state: ApplicationState,
    idSpecifica: string, 
    tipologia: TipoIntervento, 
    refreshCache: boolean
): Promise<TipiRichiestaRiepiloghiSpecifica> => {
    const url: string = '/api/tipiRichiesta/riepiloghi';
    const requestCache: RequestCache = refreshCache ? "reload" : "default";
    const filtro: Object = {
        idSpecifica, 
        tipologia 
    };

    return query<TipiRichiestaRiepiloghiSpecifica>(url, state, filtro, requestCache);
}

export const getAllTickets = (
    state: ApplicationState,
    search: string, 
    page: number, 
    refreshCache: boolean,
    tipoIntervento?: TipoIntervento, 
    stato?: StatoFiltroChiamate
): Promise<PageResult<Chiamata>> => {
    const url: string = '/api/chiamate';
    const requestCache: RequestCache = refreshCache ? "reload" : "default";
    const filtro = {
        search,
        page,
        tipoIntervento,
        stato,
    };

    return query(url, state, filtro, requestCache);
}

export const saveTicket = (
    state: ApplicationState,
    ticket: ChiamataNew
): Promise<string> => {
    const url = '/api/chiamate';

    const data = new FormData();
    data.append('idSpecifica', ticket.idSpecifica);
    data.append('idTipoRichiesta', ticket.idTipoRichiesta);
    data.append('tipoIntervento', String(ticket.tipoIntervento));
    data.append('descrizioneAggiuntiva', ticket.descrizioneAggiuntiva);
    data.append('inviaMail', String(ticket.inviaMail));
    data.append('email', ticket.email);
    data.append('referente', ticket.referente);
    if (ticket.allegati !== undefined && ticket.allegati.length > 0) {
        ticket.allegati.forEach(allegato => data.append('allegati', allegato));
    }

    return command(url, state, data);
}